import { gql } from '@apollo/client';
import { client as apolloClient } from '@xbcb/apollo-client';

const GET_IMPORTER_ENTITY_ACTIVATION_QUERY = gql`
  query ImporterEntityActivation($id: ID!) {
    importerEntityActivation(id: $id) {
      id
      importerEntity {
        id
        importer {
          id
          owners {
            customerId
            type
          }
        }
      }
      usIor {
        id
        importer {
          id
          owners {
            customerId
            type
          }
        }
      }
    }
  }
`;

type Owner = { customerId: string; type: string };

const getShipperIdFromOwners = (
  owners: Owner[] | null | undefined,
): string | null => {
  const owner = owners?.find((o) => o.type === 'globalLogisticsProfileId');
  return owner?.customerId || null;
};

export const getIorIdByWorkOrderId = async (
  workOrderId: string,
): Promise<{ iorId: string | null; shipperId: string | null }> => {
  try {
    const { data } = await apolloClient.query({
      query: GET_IMPORTER_ENTITY_ACTIVATION_QUERY,
      variables: {
        id: workOrderId,
      },
    });

    const iorId =
      data?.importerEntityActivation?.importerEntity?.id ||
      data?.importerEntityActivation?.usIor?.id ||
      null;

    const owners =
      data?.importerEntityActivation?.importerEntity?.importer?.owners ||
      data?.importerEntityActivation?.usIor?.importer?.owners;
    const shipperId = getShipperIdFromOwners(owners);

    return { iorId, shipperId };
  } catch (error) {
    console.error(`Failed to get IOR ID for work order ${workOrderId}:`, error);
    return { iorId: null, shipperId: null };
  }
};
